import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';

class ShareService {
    static getWatchRegisters = (userSub, lastKey) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ShareService}${platformId}/watch`,
            method: 'PUT',
            body: {
                userSub,
                lastKey
            }
        });
    }

    static deleteWatchRegister = (userSub, identifier, recipient) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.ShareService}${platformId}/watch`,
            method: 'DELETE',
            body: {
                userSub,
                identifier,
                recipient
            }
        });
    }

    static shareFile = (recipient, reference, subject, body, attachments) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.ShareService}${platformId}`,
            method: 'PUT',
            body: {
                recipient,
                reference,
                title: subject,
                body: body,
                attachments: attachments
            }
        });
    }
}
export default ShareService;